import { styled as o } from "styled-components";
import { MediaQuery as t } from "../../styles/variables.js";
import { Icon as i } from "../Icon/index.js";
import { ListItem as e } from "../ListItem/index.js";
import { BodyHeavy as n } from "../../styles/typography/index.js";
import { SmartLink as m } from "../SmartLink/index.js";
import { Theme as r } from "../../styles/themes/index.js";
const g = o.div`
  background-color: rgb(${r.colors.Kilo});
  min-width: 260px;

  @media ${t.SCREEN_MD_UP} {
    background-color: rgb(${r.colors.Juliet});
    padding-bottom: 24px;
    border-radius: 0 0 8px 8px;
  }
`, E = o.ul`
  padding: none;

  @media ${t.SCREEN_MD_UP} {
    max-height: 500px;
    height: auto;
    overflow-y: scroll;
  }
`, b = o(e)`
  margin-bottom: 4px;
  &:hover {
    background-color: rgb(${r.colors.Papa});
  }

  @media ${t.SCREEN_MD_UP} {
    padding-left: 18px;
    margin-bottom: none;
  }
`, f = o.div`
  ${n}
  padding: 16px;
  display: flex;
  align-items: center;
  color: rgb(${r.colors.Alpha});

  @media ${t.SCREEN_MD_UP} {
    padding: 24px 8px 16px 24px;
  }
`, $ = o(i)`
  margin-left: 4px;
  font-size: 24px;
  color: rgb(${r.colors.Brand});
`, h = o(m)`
  text-decoration: none;
  color: inherit;
`;
export {
  b as ExploreListItem,
  h as ExploreListItemLink,
  g as ExploreListItemsContainer,
  E as ExploreListItemsContent,
  f as ExploreListItemsTitle,
  $ as ExploreListItemsTitleIcon
};
